export default "__VITE_ASSET__CCAAB91x__"